import React, { useEffect } from "react";

const ImageModal = ({ open, src, alt = "image", onClose }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* backdrop */}
      <button
        type="button"
        className="absolute inset-0 bg-black/70"
        aria-label="닫기"
        onClick={onClose}
      />
      {/* content */}
      <div className="relative max-w-[90vw] max-h-[90vh] p-2">
        <img
          src={src}
          alt={alt}
          className="max-w-[90vw] max-h-[90vh] object-contain rounded-xl shadow-2xl"
        />
        <button
          type="button"
          onClick={onClose}
          className="absolute -top-10 right-0 text-white/90 hover:text-white px-3 py-2"
          aria-label="닫기"
          title="닫기(Esc)"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default ImageModal;
